import * as e from "react";
import r from "../lib/IconBase.es.js";
import l from "../defs/Wallet.es.js";
const o = e.forwardRef((t, a) => /* @__PURE__ */ e.createElement(r, { ref: a, ...t, weights: l }));
o.displayName = "WalletIcon";
const s = o;
export {
  s as Wallet,
  o as WalletIcon
};
